'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useRef } from 'react';
const defaultBusPayload = {
  on: () => () => null,
  off: () => null,
  emit: () => null
};
const BusContext = createContext(defaultBusPayload);
export const useEvents = () => {
  return useContext(BusContext);
};
export const useListener = (eventName, eventHandler) => {
  const $ = _c(5);
  const {
    on
  } = useEvents();
  let t0;
  let t1;
  if ($[0] !== eventHandler || $[1] !== eventName || $[2] !== on) {
    t0 = () => {
      const unbind = on(eventName, eventHandler);
      return () => unbind();
    };
    t1 = [on, eventName, eventHandler];
    $[0] = eventHandler;
    $[1] = eventName;
    $[2] = on;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};
export const useEmitter = (eventName, ...t0) => {
  const $ = _c(4);
  const args = t0;
  const {
    emit
  } = useEvents();
  let t1;
  if ($[0] !== args || $[1] !== emit || $[2] !== eventName) {
    t1 = () => {
      emit(eventName, ...args);
    };
    $[0] = args;
    $[1] = emit;
    $[2] = eventName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleEmit = t1;
  return handleEmit;
};
export const BusProvider = ({
  children
}) => {
  const $events = useRef({});
  const off = (eventName, eventHandler) => {
    $events.current[eventName] = $events.current[eventName]?.filter(e => eventHandler !== e);
  };
  const on = (eventName_0, eventHandler_0) => {
    $events.current[eventName_0] ??= [];
    $events.current[eventName_0].push(eventHandler_0);
    return () => off(eventName_0, eventHandler_0);
  };
  const emit = (eventName_1, ...args) => {
    const handlers = $events.current[eventName_1] ?? [];
    handlers.forEach(handler => handler(...args));
  };
  return <BusContext.Provider value={{
    on,
    off,
    emit
  }}>{children}</BusContext.Provider>;
};